import { DatePicker as AntdDatePicker, Form } from "antd"
import { DatePickerWrapper } from "./styles";

const DatePicker = (props: any) => {
    const { formItem, ...rest } = props;
    return (
        <DatePickerWrapper>
            <Form.Item {...formItem}>
                <AntdDatePicker {...rest} />
            </Form.Item>
        </DatePickerWrapper>
    )
}

export default DatePicker;